module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "datatable"
    }
  }, [_c('v-data-table', {
    class: _vm.$attrs.customWidth ? 'width_control' : '',
    attrs: {
      "single-select": "",
      "headers": _vm.headers,
      "items": _vm.currentPageItems,
      "page": _vm.currentPage,
      "items-per-page": _vm.customPaginationPerPage,
      "item-key": "no",
      "single-expand": true,
      "expanded": _vm.expanded,
      "hide-default-footer": "",
      "show-expand": "",
      "loading-text": "Loading... Please wait",
      "height": "auto"
    },
    on: {
      "update:page": function($event) {
        _vm.currentPage = $event
      },
      "update:expanded": function($event) {
        _vm.expanded = $event
      },
      "dblclick:row": _vm.selectRowAndFinish,
      "item-expanded": _vm.loadDetailExpanded,
      "click:row": _vm.rowClick
    },
    scopedSlots: _vm._u([{
      key: "item.label",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', [_vm._v(_vm._s(item.label ? item.label.replace(/ /g, " ") : item.label))])]
      }
    }, {
      key: "item.no",
      fn: function(ref) {
        var index = ref.index;

        return [_vm._v("\n            " + _vm._s(10 * (_vm.currentPage - 1) + (index + 1)) + "\n        ")]
      }
    }, {
      key: "item.is_restricted",
      fn: function(ref) {
        var item = ref.item;

        return [(!item.is_restricted) ? _c('v-icon', {
          attrs: {
            "color": "green3"
          }
        }, [_vm._v("mdi-checkbox-marked")]) : _c('v-icon', {
          attrs: {
            "color": "darkFade"
          }
        }, [_vm._v("mdi-close-box")])]
      }
    }, {
      key: "item.is_home",
      fn: function(ref) {
        var item = ref.item;

        return [(!item.is_home) ? _c('v-icon', {
          attrs: {
            "color": "green3"
          }
        }, [_vm._v("mdi-checkbox-marked")]) : _c('v-icon', {
          attrs: {
            "color": "darkFade"
          }
        }, [_vm._v("mdi-close-box")])]
      }
    }, {
      key: "item.is_live_class",
      fn: function(ref) {
        var item = ref.item;

        return [(!item.is_live_class) ? _c('v-icon', {
          attrs: {
            "color": "green3"
          }
        }, [_vm._v("mdi-checkbox-marked")]) : _c('v-icon', {
          attrs: {
            "color": "darkFade"
          }
        }, [_vm._v("mdi-close-box")])]
      }
    }, {
      key: "item.is_specific",
      fn: function(ref) {
        var item = ref.item;

        return [(item.is_specific != null) ? _c('div', [(item.is_specific) ? _c('v-icon', {
          attrs: {
            "color": "green3"
          }
        }, [_vm._v("mdi-checkbox-marked")]) : _c('v-icon', {
          attrs: {
            "color": "darkFade"
          }
        }, [_vm._v("mdi-close-box")])], 1) : _vm._e()]
      }
    }, {
      key: "expanded-item",
      fn: function() {
        return [(_vm.routeMenu === 'transaksi') ? [_c('td'), _vm._v(" "), _c('td', {
          staticClass: "pa-3",
          attrs: {
            "valign": "top"
          }
        }, [_c('table', {
          staticClass: "table-detail"
        }, [_c('tr', [_c('td', {
          staticClass: "grey--text",
          attrs: {
            "valign": "top"
          }
        }, [_vm._v("Nama")]), _vm._v(" "), _c('td', {
          staticClass: "pl-2",
          attrs: {
            "valign": "top"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm.rowDetail.nama_siswa) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "grey--text",
          attrs: {
            "valign": "top"
          }
        }, [_vm._v("\n                                Order id\n                            ")]), _vm._v(" "), _c('td', {
          staticClass: "pl-2",
          attrs: {
            "valign": "top"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm.rowDetail.id) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "grey--text",
          attrs: {
            "valign": "top"
          }
        }, [_vm._v("No Hp")]), _vm._v(" "), _c('td', {
          staticClass: "pl-2",
          attrs: {
            "valign": "top"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm.rowDetail.handphone) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "grey--text",
          attrs: {
            "valign": "top"
          }
        }, [_vm._v("Sekolah")]), _vm._v(" "), _c('td', {
          staticClass: "pl-2",
          attrs: {
            "valign": "top"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm.rowDetail.school) + "\n                            ")])])])]), _vm._v(" "), _c('td', {
          staticClass: "pa-3",
          attrs: {
            "colspan": "2",
            "valign": "top"
          }
        }, [_c('table', {
          staticClass: "table-detail"
        }, [_c('tr', [_c('td', {
          staticClass: "grey--text"
        }, [_vm._v("Nama Group")]), _vm._v(" "), _c('td', {
          staticClass: "pl-2"
        }, [_vm._v(_vm._s(_vm.rowDetail.paket))])])])]), _vm._v(" "), _c('td', {
          staticClass: "pa-3",
          attrs: {
            "valign": "top",
            "colspan": "2"
          }
        }, [_c('table', {
          staticClass: "table-detail"
        }, [_c('tr', [_c('td', {
          staticClass: "grey--text",
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "valign": "top"
          }
        }, [_vm._v("\n                                No. Rekening\n                            ")]), _vm._v(" "), _c('td', {
          staticClass: "pl-2",
          attrs: {
            "valign": "top"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm.rowDetail.payment_account) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "grey--text",
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "valign": "top"
          }
        }, [_vm._v("\n                                Bank\n                            ")]), _vm._v(" "), _c('td', {
          staticClass: "pl-2",
          attrs: {
            "valign": "top"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm.rowDetail.payment_company) + "\n                            ")])])])])] : _vm._e(), _vm._v(" "), (_vm.routeMenu === 'konsul') ? [_c('td', {
          staticClass: "pa-3",
          attrs: {
            "valign": "top"
          }
        }, [_c('table', {
          staticClass: "table-detail"
        }, [_c('tr', [_c('td', {
          staticClass: "grey--text",
          attrs: {
            "valign": "top"
          }
        }, [_vm._v("\n                                Student id\n                            ")]), _vm._v(" "), _c('td', {
          staticClass: "pl-2",
          attrs: {
            "valign": "top"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm.rowDetail.student_id) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "grey--text",
          attrs: {
            "valign": "top"
          }
        }, [_vm._v("Kelas")]), _vm._v(" "), _c('td', {
          staticClass: "pl-2",
          attrs: {
            "valign": "top"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm.rowDetail.id) + "\n                            ")])])])]), _vm._v(" "), _c('td', {
          staticClass: "pa-3",
          attrs: {
            "valign": "top"
          }
        }, [_c('table', {
          staticClass: "table-detail"
        }, [_c('tr', [_c('td', {
          staticClass: "grey--text"
        }, [_vm._v("Teacher id")]), _vm._v(" "), _c('td', {
          staticClass: "pl-2"
        }, [_vm._v(_vm._s(_vm.rowDetail.teacher_id))])])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
          staticClass: "pa-3",
          attrs: {
            "valign": "top"
          }
        }, [_c('table', {
          staticClass: "table-detail"
        }, [_c('tr', [_c('td', {
          staticClass: "grey--text",
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "valign": "top"
          }
        }, [_vm._v("\n                                Mulai\n                            ")]), _vm._v(" "), _c('td', {
          staticClass: "pl-2",
          attrs: {
            "valign": "top"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm.expanded_consule_start_time) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "grey--text",
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "valign": "top"
          }
        }, [_vm._v("\n                                Selesai\n                            ")]), _vm._v(" "), _c('td', {
          staticClass: "pl-2",
          attrs: {
            "valign": "top"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm.expanded_consule_end_time) + "\n                            ")])])])]), _vm._v(" "), _c('td', {
          staticClass: "pa-3",
          attrs: {
            "valign": "top",
            "colspan": "2"
          }
        }, [_c('table', {
          staticClass: "table-detail"
        }, [_c('tr', [_c('td', {
          staticClass: "grey--text",
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "valign": "top"
          }
        }, [_vm._v("\n                                Sesi Terpakai\n                            ")]), _vm._v(" "), _c('td', {
          staticClass: "pl-2",
          attrs: {
            "valign": "top"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm.rowDetail.total_session || "-") + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "grey--text",
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "valign": "top"
          }
        }, [_vm._v("\n                                Tambah Sesi\n                            ")]), _vm._v(" "), _c('td', {
          staticClass: "pl-2",
          attrs: {
            "valign": "top"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm.rowDetail.add_on || "-") + "\n                            ")])])])])] : _vm._e()]
      },
      proxy: true
    }, {
      key: "item.status",
      fn: function(ref) {
        var item = ref.item;

        return [(item.status === 'PENDING') ? _c('v-btn', {
          staticStyle: {
            "color": "#3a89d3"
          },
          attrs: {
            "small": "",
            "depressed": "",
            "rounded": "",
            "color": "#E8F5FA"
          }
        }, [_vm._v("\n                Pending\n            ")]) : _vm._e(), _vm._v(" "), (item.status === null) ? _c('v-btn', {
          staticStyle: {
            "color": "orange"
          },
          attrs: {
            "small": "",
            "depressed": "",
            "rounded": "",
            "color": "#FFF3E0"
          }
        }) : _vm._e(), _vm._v(" "), (item.status === 'FAILED') ? _c('v-btn', {
          staticStyle: {
            "color": "#ec675e"
          },
          attrs: {
            "small": "",
            "depressed": "",
            "rounded": "",
            "color": "#FFE5E5"
          }
        }, [_vm._v("\n                Failed\n            ")]) : _vm._e(), _vm._v(" "), (item.status === 'SUCCESS') ? _c('v-btn', {
          staticStyle: {
            "color": "#40bf75"
          },
          attrs: {
            "small": "",
            "depressed": "",
            "rounded": "",
            "color": "#EEFFE0"
          }
        }, [_vm._v("\n                Success\n            ")]) : _vm._e(), _vm._v(" "), (item.status === 'finished') ? _c('v-btn', {
          staticStyle: {
            "color": "#40bf75"
          },
          attrs: {
            "small": "",
            "depressed": "",
            "rounded": "",
            "color": "#EEFFE0"
          }
        }, [_vm._v("\n                Finished\n            ")]) : _vm._e(), _vm._v(" "), (item.status === 'canceled') ? _c('v-btn', {
          staticStyle: {
            "color": "#ec675e"
          },
          attrs: {
            "small": "",
            "depressed": "",
            "rounded": "",
            "color": "#FFE5E5"
          }
        }, [_vm._v("\n                Canceled\n            ")]) : _vm._e(), _vm._v(" "), (item.status === 'timeout') ? _c('v-btn', {
          staticStyle: {
            "color": "orange"
          },
          attrs: {
            "small": "",
            "depressed": "",
            "rounded": "",
            "color": "#FFF3E0"
          }
        }, [_vm._v("\n                Timeout\n            ")]) : _vm._e(), _vm._v(" "), (item.status === 'started') ? _c('v-btn', {
          staticStyle: {
            "color": "#3a89d3"
          },
          attrs: {
            "small": "",
            "depressed": "",
            "rounded": "",
            "color": "#E8F5FA"
          }
        }, [_vm._v("\n                Started\n            ")]) : _vm._e()]
      }
    }, {
      key: "item.actions",
      fn: function(ref) {
        var item = ref.item;

        return [(_vm.hasAction) ? _c('v-menu', {
          attrs: {
            "offset-y": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('div', _vm._g(_vm._b({
                attrs: {
                  "icon": ""
                }
              }, 'div', attrs, false), on), [_c('v-icon', {
                attrs: {
                  "color": "#4F4F4F",
                  "id": "datatable_dot_btn"
                }
              }, [_vm._v("\n                            mdi-dots-vertical\n                        ")])], 1)]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-list', [(!_vm.hasPreviewSoal) ? _c('v-list-item', {
          staticClass: "test_cursor",
          attrs: {
            "id": "datatable_detail_btn",
            "link": ""
          },
          on: {
            "click": function($event) {
              return _vm.selectRowAndFinish(item.no)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Detail")])], 1) : _vm._e(), _vm._v(" "), (_vm.hasPreviewSoal) ? _c('v-list-item', {
          staticClass: "test_cursor",
          attrs: {
            "id": "datatable_detail_btn",
            "link": ""
          },
          on: {
            "click": function($event) {
              return _vm.editItem(item.no)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Detail")])], 1) : _vm._e(), _vm._v(" "), (_vm.$route.name != 'AmbisMeter') ? _c('v-list-item', {
          staticClass: "test_cursor",
          attrs: {
            "id": "datatable_delete_btn",
            "link": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteItem(item.no)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Hapus")])], 1) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'AmbisMeter') ? _c('v-list-item', {
          staticClass: "test_cursor",
          attrs: {
            "id": "datatable_leaderboard_btn",
            "link": ""
          },
          on: {
            "click": function($event) {
              return _vm.toLeaderboard(item.no)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Leaderboard")])], 1) : _vm._e(), _vm._v(" "), (_vm.hasPreview) ? _c('v-list-item', {
          staticClass: "test_cursor",
          attrs: {
            "id": "datatable_preview_btn",
            "link": "",
            "href": item.preview,
            "target": "_blank"
          }
        }, [_c('v-list-item-title', [_vm._v("Preview")])], 1) : _vm._e(), _vm._v(" "), (_vm.hasPreviewSoal) ? _c('v-list-item', {
          staticClass: "test_cursor",
          attrs: {
            "id": "datatable_preview_soal_btn",
            "link": ""
          },
          on: {
            "click": function($event) {
              return _vm.previewItem(item.no)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Preview")])], 1) : _vm._e(), _vm._v(" "), (_vm.hasPreviewSoal) ? _c('v-list-item', {
          staticClass: "test_cursor",
          attrs: {
            "id": "open_new_tab_preview_soal_btn",
            "link": ""
          },
          on: {
            "click": function($event) {
              return _vm.openNewTab(item.no)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Open New Tab")])], 1) : _vm._e(), _vm._v(" "), (_vm.hasOpenNewTab) ? _c('v-list-item', {
          staticClass: "test_cursor",
          attrs: {
            "id": "open_new_tab_preview_soal_btn",
            "link": ""
          },
          on: {
            "click": function($event) {
              return _vm.openNewTab(item.no)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Open New Tab")])], 1) : _vm._e(), _vm._v(" "), (_vm.hasReview) ? _c('v-list-item', {
          staticClass: "test_cursor",
          attrs: {
            "id": "open_new_tab_preview_soal_btn",
            "link": ""
          },
          on: {
            "click": function($event) {
              return _vm.openReview(item.no)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Preview Soal")])], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.hasDetail) ? _c('v-btn', {
          staticClass: "pa-0",
          staticStyle: {
            "justify-content": "unset !important"
          },
          attrs: {
            "id": "datatable_detail_btn",
            "color": "blew",
            "min-width": "unset",
            "height": "unset",
            "text": ""
          },
          on: {
            "click": function($event) {
              return _vm.selectRowAndFinish(item.no)
            }
          }
        }, [_vm._v("\n                Ubah\n            ")]) : _vm._e(), _vm._v(" "), (_vm.hasDuplicate) ? _c('v-menu', {
          attrs: {
            "offset-y": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('div', _vm._g(_vm._b({
                attrs: {
                  "icon": ""
                }
              }, 'div', attrs, false), on), [_c('v-icon', {
                attrs: {
                  "color": "#4F4F4F",
                  "id": "datatable_dot_btn"
                }
              }, [_vm._v("\n                            mdi-dots-vertical\n                        ")])], 1)]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
          staticClass: "test_cursor",
          attrs: {
            "id": "datatable_duplicate_btn",
            "link": ""
          },
          on: {
            "click": function($event) {
              return _vm.duplicateItem(item.no)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Duplicate")])], 1), _vm._v(" "), _c('v-list-item', {
          staticClass: "test_cursor",
          attrs: {
            "id": "datatable_export_btn",
            "link": ""
          },
          on: {
            "click": function($event) {
              return _vm.exportItem(item.no)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Export")])], 1), _vm._v(" "), _c('v-list-item', {
          staticClass: "test_cursor",
          attrs: {
            "id": "datatable_open_new_tab_btn",
            "link": ""
          },
          on: {
            "click": function($event) {
              return _vm.openNewTab(item.no)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Open New Tab")])], 1), _vm._v(" "), (_vm.hasReview) ? _c('v-list-item', {
          staticClass: "test_cursor",
          attrs: {
            "id": "open_new_tab_preview_soal_btn",
            "link": ""
          },
          on: {
            "click": function($event) {
              return _vm.openReview(item.no)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Preview Soal")])], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.hasDownload) ? _c('v-btn', {
          staticClass: "pa-2",
          staticStyle: {
            "min-width": "0 !important"
          },
          attrs: {
            "id": "datatable_detail_btn",
            "depressed": "",
            "small": "",
            "height": "33px",
            "color": "#E8F5FA"
          },
          on: {
            "click": function($event) {
              return _vm.downloadFile(item)
            }
          }
        }, [_c('v-icon', {
          staticStyle: {
            "font-size": "18px"
          },
          attrs: {
            "color": "blew"
          }
        }, [_vm._v("\n                    mdi-tray-arrow-down\n                ")])], 1) : _vm._e()]
      }
    }, {
      key: "top",
      fn: function() {
        return [_c('v-card-text', {
          staticClass: "py-0"
        }, [_c('v-container', {
          attrs: {
            "fluid": ""
          }
        }, [_c('v-row', {
          staticClass: "mt-3"
        }, [_c('v-col', {
          attrs: {
            "cols": "*"
          }
        }, [(_vm.$route.name != 'UserGroupForm') ? _c('v-text-field', {
          staticClass: "search_box",
          attrs: {
            "id": "datatable_search",
            "hide-details": "",
            "placeholder": "Search",
            "height": "36px",
            "outlined": ""
          },
          on: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.doFilter()
            }
          },
          model: {
            value: (_vm.query),
            callback: function($$v) {
              _vm.query = $$v
            },
            expression: "query"
          }
        }, [_c('template', {
          slot: "append"
        }, [(
          !(
            _vm.$store.state.datatable
            .filter.value ||
            _vm.$store.state.datatable
            .filters.length > 0
          )
        ) ? _c('svg', {
          staticClass: "test_cursor",
          attrs: {
            "id": "datatable_search_btn",
            "width": "40",
            "height": "40",
            "viewBox": "0 0 40 40",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          },
          on: {
            "click": function($event) {
              return _vm.doFilter()
            }
          }
        }, [_c('rect', {
          attrs: {
            "width": "40",
            "height": "42",
            "rx": "10",
            "fill": "#868EA4"
          }
        }), _vm._v(" "), _c('path', {
          attrs: {
            "d": "M18 24C19.775 23.9996 21.4988 23.4054 22.897 22.312L27.293 26.708L28.707 25.294L24.311 20.898C25.405 19.4997 25.9996 17.7754 26 16C26 11.589 22.411 8 18 8C13.589 8 10 11.589 10 16C10 20.411 13.589 24 18 24ZM18 10C21.309 10 24 12.691 24 16C24 19.309 21.309 22 18 22C14.691 22 12 19.309 12 16C12 12.691 14.691 10 18 10Z",
            "fill": "white"
          }
        }), _vm._v(" "), _c('path', {
          attrs: {
            "d": "M19.4121 14.5851C19.7911 14.9651 20.0001 15.4671 20.0001 15.9991H22.0001C22.001 15.4735 21.8977 14.953 21.6961 14.4676C21.4946 13.9822 21.1989 13.5415 20.8261 13.1711C19.3121 11.6591 16.6871 11.6591 15.1741 13.1711L16.5861 14.5871C17.3461 13.8291 18.6561 13.8311 19.4121 14.5851Z",
            "fill": "white"
          }
        })]) : _vm._e(), _vm._v(" "), (
          _vm.$store.state.datatable.filter
          .value ||
          _vm.$store.state.datatable.filters
          .length > 0
        ) ? _c('svg', {
          staticClass: "test_cursor",
          attrs: {
            "id": "datatable_clear_search_btn",
            "width": "40",
            "height": "36",
            "viewBox": "0 0 40 36",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          },
          on: {
            "click": function($event) {
              return _vm.clearFilter()
            }
          }
        }, [_c('rect', {
          attrs: {
            "width": "40",
            "height": "36",
            "rx": "6",
            "fill": "#2690CB"
          }
        }), _vm._v(" "), _c('path', {
          attrs: {
            "d": "M21.4109 18.0002L25.7109 13.7102C25.8992 13.5219 26.005 13.2665 26.005 13.0002C26.005 12.7339 25.8992 12.4785 25.7109 12.2902C25.5226 12.1019 25.2672 11.9961 25.0009 11.9961C24.7346 11.9961 24.4792 12.1019 24.2909 12.2902L20.0009 16.5902L15.7109 12.2902C15.5226 12.1019 15.2672 11.9961 15.0009 11.9961C14.7346 11.9961 14.4792 12.1019 14.2909 12.2902C14.1026 12.4785 13.9968 12.7339 13.9968 13.0002C13.9968 13.2665 14.1026 13.5219 14.2909 13.7102L18.5909 18.0002L14.2909 22.2902C14.1972 22.3832 14.1228 22.4938 14.072 22.6156C14.0213 22.7375 13.9951 22.8682 13.9951 23.0002C13.9951 23.1322 14.0213 23.2629 14.072 23.3848C14.1228 23.5066 14.1972 23.6172 14.2909 23.7102C14.3839 23.8039 14.4945 23.8783 14.6163 23.9291C14.7382 23.9799 14.8689 24.006 15.0009 24.006C15.1329 24.006 15.2636 23.9799 15.3855 23.9291C15.5074 23.8783 15.618 23.8039 15.7109 23.7102L20.0009 19.4102L24.2909 23.7102C24.3839 23.8039 24.4945 23.8783 24.6163 23.9291C24.7382 23.9799 24.8689 24.006 25.0009 24.006C25.1329 24.006 25.2636 23.9799 25.3855 23.9291C25.5074 23.8783 25.618 23.8039 25.7109 23.7102C25.8046 23.6172 25.879 23.5066 25.9298 23.3848C25.9806 23.2629 26.0067 23.1322 26.0067 23.0002C26.0067 22.8682 25.9806 22.7375 25.9298 22.6156C25.879 22.4938 25.8046 22.3832 25.7109 22.2902L21.4109 18.0002Z",
            "fill": "white"
          }
        })]) : _vm._e()]), _vm._v(" "), _c('template', {
          slot: "prepend-inner"
        }, [_c('div', {
          staticClass: "inside_search"
        }, [_c('v-select', {
          staticStyle: {
            "width": "104px",
            "display": "inline-flex"
          },
          attrs: {
            "id": "datatable_search_filters",
            "height": "36px",
            "hide-details": "",
            "small": "",
            "placeholder": "Filter",
            "items": _vm.headerKeys,
            "item-text": "text",
            "item-value": "value",
            "outlined": "",
            "return-object": ""
          },
          model: {
            value: (_vm.field),
            callback: function($$v) {
              _vm.field = $$v
            },
            expression: "field"
          }
        })], 1)])], 2) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
          attrs: {
            "cols": "2"
          }
        }, [(_vm.$route.name != 'UserGroupForm') ? _c('v-select', {
          staticClass: "select_box",
          attrs: {
            "id": "datatable_sort",
            "disabled": _vm.$route.name === 'ItemBank' ||
              _vm.$route.name === 'Leaderboard',
            "height": "36px",
            "hide-details": "",
            "placeholder": "Urutkan",
            "outlined": "",
            "items": [{
                text: 'Baru ke Lama',
                value: 'desc'
              },
              {
                text: 'Lama ke Baru',
                value: 'asc'
              } ],
            "item-text": "text",
            "item-value": "value"
          },
          on: {
            "change": _vm.updateOrderBy
          },
          model: {
            value: (_vm.orderBy),
            callback: function($$v) {
              _vm.orderBy = $$v
            },
            expression: "orderBy"
          }
        }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', {
          staticClass: "my-3"
        }, [_c('v-col', {
          attrs: {
            "cols": "*"
          }
        }, _vm._l((_vm.$store.state
          .datatable.filters), function(filter, key) {
          return _c('v-chip', {
            key: key,
            staticClass: "mt-4 mr-4",
            attrs: {
              "color": "blew",
              "label": "",
              "dark": "",
              "small": "",
              "id": 'datatable_filter_' + key
            }
          }, [_c('span', {
            staticClass: "pr-2"
          }, [_vm._v("\n                                    " + _vm._s(filter.key.text) + " =\n                                    " + _vm._s(filter.value) + "\n                                ")]), _vm._v(" "), _c('v-icon', {
            attrs: {
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.delByOneFilter(key)
              }
            }
          }, [_vm._v("\n                                    mdi-close-circle\n                                ")])], 1)
        }), 1)], 1)], 1)], 1)]
      },
      proxy: true
    }], null, true)
  }), _vm._v(" "), (_vm.hasCustomPagination && _vm.customPaginationTotalPages === 0) ? _c('div', {
    staticClass: "d-flex space-between pa-4"
  }, [_c('span', {
    staticClass: "gray3--text"
  }, [_vm._v("\n            Menampilkan " + _vm._s(_vm.items.length * _vm.currentPage) + " dari -\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "pa-0",
    attrs: {
      "depressed": "",
      "disabled": _vm.currentPage == 1,
      "min-width": "32px",
      "height": "32px"
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(--_vm.currentPage)
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-left")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "pa-0 mx-2",
    attrs: {
      "depressed": "",
      "dark": "",
      "color": "blew",
      "min-width": "32px",
      "height": "32px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.currentPage) + "\n        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "pa-0",
    attrs: {
      "depressed": "",
      "min-width": "32px",
      "height": "32px",
      "disabled": _vm.items.length < _vm.customPaginationPerPage
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(++_vm.currentPage)
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1) : _c('div', {
    staticClass: "d-flex align-center space-between pa-4"
  }, [_c('span', {
    staticClass: "gray3--text"
  }, [_vm._v("\n            Menampilkan\n            " + _vm._s(_vm.customPaginationPerPage * (_vm.currentPage - 1) + 1) + "\n            sampai\n            " + _vm._s(_vm.customPaginationPerPage * _vm.currentPage > _vm.items.length ?
    _vm.customPaginationTotalItems ?
    _vm.customPaginationTotalItems :
    _vm.customPaginationPerPage * (_vm.currentPage - 1) +
    _vm.items.length :
    _vm.customPaginationPerPage * _vm.currentPage) + "\n            dari\n            " + _vm._s(_vm.customPaginationTotalItems ?
    _vm.customPaginationTotalItems + " entri" :
    " -") + "\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-pagination', {
    attrs: {
      "color": "blew",
      "length": _vm.maxPage,
      "total-visible": 5
    },
    on: {
      "input": _vm.currentPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25760777","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/global/components/plugins/DataTableDropdown.vue
// module id = 1577
// module chunks = 1